<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="history-pages">
    <div class="history-details-header {{isHeaderAdjusted ? 'headerShiftedTrainHistory' : ''}}" id="history-info-header">
        <span class="date-information" *ngIf='fromDate && toDate'>From {{fromDate}} to {{toDate}} </span>
        <span class="paging-information">Showing {{showingFrom}} to {{showingTo}} of {{totalRecords}} records</span>
    </div>

    <div class="history-tbl-container">
        <ul id="commonHistoryHeader" class="history-tbl-header">
            <li>Date Time </li>
            <li class="history-tbl-text-col">Text </li>
            <li>Terminal </li>
            <li *ngIf='historyOps?.displayType !== "F"'> Subyard</li>
            <li *ngIf='historyOps?.displayType !== "F"'> Train </li>
            <li *ngIf='historyOps?.displayType === "F"'>Site MP</li>
            <li *ngIf='historyOps?.displayType === "F"'>Gallon</li>
            <li>Locomotive</li>
            <li class="col-userid">User ID</li>
            <li class="col-trans">Trans</li>
            <li>Event Time</li>

        </ul>
        <div id="commonHistoryData" class="historyTableBody" (scroll)='scrollEventOccured();' [style.height.px]='scrollHeight' #viewPortPaging=viewPortpaging lmsViewportPaging [child]="'commHistoryTableBody'" (getPagingData)="getPaginationData($event);">
            <ul class="commHistoryTableBody" *ngFor='let history of historyToShow; let i = index;'>
                <li>
                    {{history.date}} {{history.time}}
                </li>
                <li class="history-tbl-text-col">
                    {{history.description}}
                </li>
                <li>
                    <!-- <a *ngIf='appUtilityService.isMnemonicExist(history.terminal); else elseBlock;' href="javascript:void(0)" class="menu-item-link" (click)='routeToPage("Status", "Terminal", history.terminal);'>
                    {{history.terminal}}
                </a>
                    <ng-template #elseBlock>{{history.terminal}}</ng-template> -->

                    {{history.terminal}}
                </li>
                <li *ngIf='historyOps?.displayType !== "F"'>
                    {{history.subyard}}
                </li>
                <li *ngIf='historyOps?.displayType !== "F"'>
                    <!-- <a *ngIf='(appUtilityService.isValidTrainId(history.trainId)); else comHisTrainElse;' id="train{{i}}CommHis{{history.trainId}}" href="javascript:void(0)" class="menu-item-link" (click)='routeToPage("Data", "Train", history.trainId);' (contextmenu)='$event.preventDefault(); setOverlayLinks("train"); locomotiveOverlayPosition($event, commonHistoryOverlay, history.trainId, i, "train")'>
                        {{history.trainId}}
                    </a>
                    <ng-template #comHisTrainElse>{{history.trainId}}</ng-template> -->
                    {{history.trainId}}
                    
                </li>
                <li *ngIf='historyOps?.displayType === "F"'>
                    {{history.subyard}}
                </li>
                <li *ngIf='historyOps?.displayType === "F"'>
                    {{history.trainId}}
                </li>
                <li>
                    <a *ngIf='(appUtilityService.isValidLocomotiveId(history.locomotiveId));  else locoElseBlock;' id="locomotive{{i}}CommHis{{history.locomotiveId}}" href="javascript:void(0)" class="menu-item-link" (click)='routeToPage("Data", "Locomotive", getFormattedLocoId(history.locomotiveId));'
                        (contextmenu)='$event.preventDefault(); setOverlayLinks("loco"); locomotiveOverlayPosition($event, commonHistoryOverlay, getFormattedLocoId(history.locomotiveId), i, "loco")'>
                    {{getFormattedLocoId(history.locomotiveId)}}
                </a>
                    <ng-template #locoElseBlock>{{history.locomotiveId}}</ng-template>
                </li>
                <li class="col-userid">
                    {{history.userId}}
                </li>
                <li class="col-trans">
                    {{history.transactionId}}
                </li>
                <li>
                    {{history.eventDate}} {{history.eventTime}}
                </li>

            </ul>
        </div>
    </div>

    <div class="clear"></div>
    <div class="back-to-top" (click)='scrollTableScrollToTop()' *ngIf='isBackToTop'></div>
</div>

<p-overlayPanel #commonHistoryOverlay [dismissable]="true" id='overlayLinksInfo' [ngClass]="'menu-dropdown'">
    <ul>
        <li *ngFor="let link of overlayLinks">
            <a href="javascript:void(0)" (click)='routeToPage(link, contextType, contextSearchText); hideLocoOverlayPanel($event, commonHistoryOverlay);'>{{link}}</a>
        </li>
    </ul>
</p-overlayPanel>